(function(){
  if (window.__otcInit) return; window.__otcInit = true;
  var PREVIEW = !!window.OTC_PREVIEW;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}

  /* reveal */
  function initReveal(root){
    var els=$$('[data-reveal]',root);
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){io.observe(e)});
  }

  /* marquee: duplicate content so the -50% loop is seamless */
  function initMarquee(root){
    $$('.otc-marquee__track',root).forEach(function(t){
      if(t.dataset.ready) return; t.dataset.ready=1;
      var html=t.innerHTML; var w=t.scrollWidth||1; var n=Math.max(1,Math.ceil((window.innerWidth*1.2)/w));
      var chunk=''; for(var i=0;i<n;i++) chunk+=html; t.innerHTML=chunk+chunk;
    });
  }

  /* scroll progress vars (parallax + closer) */
  var progEls=[];
  function initProgress(root){ progEls=progEls.concat($$('[data-progress]',root)); onScroll(); }
  function onScroll(){
    var vh=window.innerHeight;
    progEls.forEach(function(el){
      var r=el.getBoundingClientRect();
      var p=1-Math.min(1,Math.max(0,(r.top)/(vh)));
      el.style.setProperty('--p',reduce?1:p.toFixed(3));
    });
  }
  window.addEventListener('scroll',function(){requestAnimationFrame(onScroll)},{passive:true});
  window.addEventListener('resize',onScroll);

  /* toast */
  var toast;
  function showToast(msg){
    if(!toast){toast=document.createElement('div');toast.className='otc otc-toast';toast.setAttribute('role','status');document.body.appendChild(toast)}
    toast.innerHTML='<span>'+msg+'</span><a href="/cart">View cart</a><a href="/checkout">Checkout</a>';
    toast.classList.add('is-on'); clearTimeout(toast._t); toast._t=setTimeout(function(){toast.classList.remove('is-on')},4200);
  }
  function refreshCartCount(){
    if(PREVIEW) return;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      $$('[data-otc-cart-count], .cart-bubble__text-count, cart-count, [ref="cartBubbleCount"]').forEach(function(el){el.textContent=c.item_count});
      $$('.cart-bubble').forEach(function(b){b.classList.toggle('visually-hidden',c.item_count===0)});
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:c}));document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:c,sourceId:'otc',data:{source:'otc',itemCount:c.item_count}}}));
    }).catch(function(){});
  }

  /* product cards */
  function initCard(card){
    if(card.dataset.ready) return; card.dataset.ready=1;
    var variants=JSON.parse(($('[data-variants]',card)||{}).textContent||'[]');
    var images=JSON.parse(($('[data-images]',card)||{}).textContent||'{}');
    var sizeIdx=parseInt(card.dataset.sizeIndex,10), colorIdx=parseInt(card.dataset.colorIndex,10);
    var hasSize=!isNaN(sizeIdx)&&sizeIdx>=0, hasColor=!isNaN(colorIdx)&&colorIdx>=0;
    var state={size:null,color:null};
    var sw=$$('.otc-swatch',card), sz=$$('.otc-size',card), add=$('.otc-card__add',card), note=$('.otc-card__note',card);
    var front=$('.otc-card__front',card), back=$('.otc-card__back',card), priceEl=$('.otc-price',card);
    if(hasColor&&sw.length){state.color=sw[0].dataset.value}
    function match(){
      return variants.filter(function(v){
        return (!hasSize||v.options[sizeIdx]===state.size)&&(!hasColor||v.options[colorIdx]===state.color);
      })[0];
    }
    function sync(){
      // size availability for chosen colour
      sz.forEach(function(b){
        var ok=variants.some(function(v){return v.available&&v.options[sizeIdx]===b.dataset.value&&(!hasColor||v.options[colorIdx]===state.color)});
        b.disabled=!ok; b.setAttribute('aria-pressed',String(state.size===b.dataset.value&&ok));
        if(!ok&&state.size===b.dataset.value) state.size=null;
      });
      sw.forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.value===state.color))});
      if(hasColor&&images[state.color]){ var im=images[state.color]; if(im[0]) front.src=im[0]; if(im[1]&&back) back.src=im[1]; }
      var v=(!hasSize||state.size)?match():null;
      if(!hasSize&&!hasColor) v=variants[0];
      var anyAvail=variants.some(function(x){return x.available&&(!hasColor||x.options[colorIdx]===state.color)});
      if(v&&v.available){
        add.disabled=false; add.textContent='Add to cart — '+v.price_fmt; add.dataset.variant=v.id;
        note.textContent=(v.qty>0&&v.qty<=3)?('Only '+v.qty+' left in '+(state.size||'stock')):'';
        if(priceEl) priceEl.innerHTML=(v.cap_fmt?'<s>'+v.cap_fmt+'</s>':'')+v.price_fmt;
      } else {
        add.disabled=true; add.dataset.variant='';
        add.textContent=anyAvail?(hasSize?'Select a size':'Add to cart'):'Sold out';
        note.textContent='';
      }
    }
    sw.forEach(function(b){b.addEventListener('click',function(){state.color=b.dataset.value;sync()})});
    sz.forEach(function(b){b.addEventListener('click',function(){state.size=b.dataset.value;sync()})});
    var flip=$('.otc-card__flip',card); if(flip) flip.addEventListener('click',function(e){e.preventDefault();card.classList.toggle('is-flipped');flip.textContent=card.classList.contains('is-flipped')?'Front':'Back'});
    add.addEventListener('click',function(){
      var id=add.dataset.variant; if(!id) return;
      var label=add.textContent; add.disabled=true; add.textContent='Adding…';
      var title=card.dataset.title+(state.size?' ('+state.size+(state.color?' / '+state.color:'')+')':'');
      var done=function(){add.textContent='Added ✓';showToast(title+' added to your cart');refreshCartCount();document.dispatchEvent(new CustomEvent('cart:add',{detail:{id:id,quantity:1}}));setTimeout(function(){add.disabled=false;add.textContent=label},1600)};
      if(PREVIEW){setTimeout(done,350);return}
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(function(r){if(!r.ok) return r.json().then(function(j){throw j});return r.json()})
        .then(done).catch(function(err){add.disabled=false;add.textContent=label;note.textContent=(err&&err.description)||'Could not add — please try again.'});
    });
    sync();
  }

  /* filter tabs */
  function initTabs(root){
    $$('[data-otc-tabs]',root).forEach(function(group){
      var grid=$(group.dataset.target)||group.closest('section').querySelector('.otc-grid');
      $$('.otc-tab',group).forEach(function(t){
        t.addEventListener('click',function(){
          $$('.otc-tab',group).forEach(function(x){x.setAttribute('aria-pressed','false')}); t.setAttribute('aria-pressed','true');
          var f=t.dataset.filter; $$('.otc-card',grid).forEach(function(c){c.hidden=!(f==='all'||c.dataset.cat===f)});
        });
      });
    });
  }

  /* spotlight views */
  function initSpot(root){
    $$('[data-otc-spot]',root).forEach(function(s){
      var imgs=$$('.otc-spot__stage img',s), btns=$$('[data-view]',s), i=0, timer;
      function go(n){i=n;imgs.forEach(function(im,k){im.classList.toggle('is-on',k===n)});btns.forEach(function(b,k){b.setAttribute('aria-pressed',String(k===n))})}
      btns.forEach(function(b,k){b.addEventListener('click',function(){clearInterval(timer);go(k)})});
      if(!reduce&&imgs.length>1){timer=setInterval(function(){go((i+1)%imgs.length)},2600)}
      go(0);
    });
  }

  /* newsletter preview */
  function initJoin(root){
    if(!PREVIEW) return;
    $$('.otc-join form',root).forEach(function(f){f.addEventListener('submit',function(e){e.preventDefault();var ok=$('.otc-join__ok',f.parentNode);if(ok) ok.hidden=false;f.reset()})});
  }

  function init(root){root=root||document;initMarquee(root);initReveal(root);initProgress(root);$$('[data-otc-card]',root).forEach(initCard);initTabs(root);initSpot(root);initJoin(root);
    $$('video[autoplay]',root).forEach(function(v){v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){})});}
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
